/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
  fill?: string,
}>;

const ContextTriangleIcon = (props: Props) => (
  <svg
    className={classNames("icons context-triangle", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="0 0 9 9"
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill={props.fill || "none"}>
      <polygon points="8 2 4.5 7 1 2" />
    </g>
  </svg>
);

export default ContextTriangleIcon;
